<template>
  <div>
    <h4></h4>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">Descripcion</th>
          <th scope="col">FechaDesde</th>
          <th scope="col">FechaHasta</th>
          <th scope="col">ClasElemNombre</th>
          <th scope="col">AseguradorNombre</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="tarifario in datosPaginados" :key="tarifario.idTarifario">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(tarifario.idTarifario)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(tarifario.idTarifario)" title="Editar">edit_square</i></td>
          <td>{{tarifario.descripcion}}</td>
          <td>{{getFormattedDate(tarifario.fechaDesde, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(tarifario.fechaHasta, 'DD/MM/YYYY')}}</td>
          <td>{{tarifario.clasElemNombre}}</td>
          <td>{{tarifario.aseguradorNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteTarifario(tarifario.idTarifario)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idTarifario" class="form-label">IdTarifario</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idTarifario" name="idTarifario" v-model="datoTarifario.idTarifario" disabled>
                </div>
              </div>
            </div>
<!-- Botón Lista de Valores  Clas Elem -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idClasElem" class="form-label"> Clas Elem</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idClasElem" name="idClasElem" v-model="datoTarifario.idClasElem">
                      <option v-for="clasElem in clasElems" :value="clasElem.idClasElem" :key="clasElem.idClasElem">
                        {{ clasElem.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Clas Elem -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="descripcion" class="form-label">Descripcion</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="descripcion" name="descripcion" v-model="datoTarifario.descripcion" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaDesde" class="form-label">FechaDesde</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaDesde" name="fechaDesde" v-model="datoTarifario.fechaDesde" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaHasta" class="form-label">FechaHasta</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaHasta" name="fechaHasta" v-model="datoTarifario.fechaHasta" required>
                </div>
              </div>
            </div>
<!-- Botón Lista de Valores  Asegurador -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idAsegurador" class="form-label"> Asegurador</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idAsegurador" name="idAsegurador" v-model="datoTarifario.idAsegurador">
                      <option v-for="asegurador in aseguradors" :value="asegurador.idAsegurador" :key="asegurador.idAsegurador">
                        {{ asegurador.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Asegurador -->
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarTarifario" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditTarifario" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
  </div>
</template>
<script>
import { validarForm } from '../../modules/validacionesForms.js'
import dateFormat from '../../modules/dateFormat.js';
import { format } from 'date-fns';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
  },
  data () {
    return {
      tarifarios : [],
      datoTarifario : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      clasElems: [],
      aseguradors: [],
    }
  },
  computed: {
    formattedFechaReg() {
      const originalDate = new Date(this.datoAuto.fechaReg);
      return format(originalDate, 'dd/MM/yyyy');
    },
  },

  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.fetchClasElems()
    this.fetchAseguradors()
  },
  methods : {
    direccionImagen(codigo){
      return `/tarifarios/${codigo}`;
    },
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas(){
      return Math.ceil(this.tarifarios.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwtarifarios/nombre/'+this.nombreBusqueda).then(response=>{ 
          this.tarifarios=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.tarifarios.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwtarifarios').then(response=>{ 
      this.tarifarios=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.tarifarios.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'idClasElem'
        ,'descripcion'
        ,'fechaDesde'
        ,'fechaHasta'
        ,'idAsegurador'
      ];
      const requiredFieldsText = [
        'idClasElem'
        ,'descripcion'
        ,'fechaDesde'
        ,'fechaHasta'
        ,'idAsegurador'
      ];
      return validarForm(this.datoTarifario, requiredFields, requiredFieldsText);
    },
    async guardarTarifario(){
      if(this.validarForm() === 1){
        try {
          await api.post('/tarifarios', this.datoTarifario)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Tarifario creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditTarifario(){
      if(this.validarForm() === 1){
        try {
          await api.post('/tarifarios', this.datoTarifario)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Tarifario creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoTarifario={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idTarifario){
      this.modalWindow = true
      if(idTarifario != null){    
           api.get('/vwtarifarios/'+idTarifario).then(resp=>{
          this.datoTarifario = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
      this.btnCrear = false
      this.btnEditar= true
    },
    abrirEditar(idTarifario){
      if(idTarifario != null){
        this.$router.push('/tarifariomd/'+idTarifario)
      }
    },
    async deleteTarifario (idTarifario) {
      try{
        await api.delete('/tarifarios/'+idTarifario)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
async fetchClasElems() {
  try {
    const response = await api.get("/vwclaselems");
    this.clasElems = response.data;
  } catch (error) {
    console.error("Error al obtener los clasElems:", error);
  }
},

async fetchAseguradors() {
  try {
    const response = await api.get("/vwaseguradors");
    this.aseguradors = response.data;
  } catch (error) {
    console.error("Error al obtener los aseguradors:", error);
  }
},
  },
}
</script>